/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export class ProcessQResponseMessage {
  raw: any;
  header?: any = {};
  vipList?: any;
  calloutList?: any;
  normalList?: any;
  othersValue?: string;
  queueHeader: {
    othersValue?: string;
    lockValue?: string;
    vipValue?: string;
  } = {};
  isDataChanged?: boolean;
  distCounterMid?: string;
  constructor({ raw }: { raw: any }) {
    this.raw = raw;
    this.isDataChanged = false;
  }
}
